module.exports = __webpack_public_path__ + "static/media/right.bd509ade.svg";